module.exports = __webpack_public_path__ + "static/media/ki.db7e40f6.svg";